export interface Category {
  key: string;
  url: string;
  image: string;
}

export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export const categories: Category[] = [
  {
    key: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20crisp%20white%20leather%20sneakers%20resting%20on%20a%20light%20wooden%20shelf%20beside%20a%20small%20potted%20green%20plant%2C%20soft%20warm%20morning%20sunlight%20from%20a%20window%2C%20cozy%20editorial%20product%20photography%2C%20shallow%20depth%20of%20field%2C%20natural%20warm%20tones%2C%20airy%20and%20inviting%20composition&width=600&height=600&seq=cat-shoes-01&orientation=squarish&nocache=true",
  },
  {
    key: "hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20cozy%20folded%20heather%20grey%20hoodie%20stacked%20on%20a%20linen%20surface%20next%20to%20a%20ceramic%20mug%20of%20coffee%20and%20a%20pair%20of%20reading%20glasses%2C%20warm%20afternoon%20light%2C%20relaxed%20lifestyle%20flat%20lay%20photography%2C%20soft%20neutral%20palette%2C%20inviting%20homey%20atmosphere&width=600&height=600&seq=cat-hoodies-01&orientation=squarish&nocache=true",
  },
  {
    key: "tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20single%20off-white%20cotton%20t-shirt%20hanging%20on%20a%20natural%20wooden%20hanger%20against%20a%20soft%20sage%20green%20wall%2C%20minimal%20wardrobe%20editorial%20photography%2C%20soft%20diffused%20daylight%2C%20gentle%20fabric%20folds%2C%20calm%20and%20clean%20aesthetic&width=600&height=600&seq=cat-tshirts-01&orientation=squarish&nocache=true",
  },
  {
    key: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20classic%20camel%20wool%20jacket%20draped%20casually%20over%20the%20back%20of%20a%20light%20oak%20chair%20in%20a%20bright%20sunlit%20room%2C%20warm%20beige%20tones%2C%20editorial%20fashion%20photography%2C%20soft%20natural%20light%20and%20gentle%20shadows%2C%20understated%20elegant%20styling&width=600&height=600&seq=cat-jackets-01&orientation=squarish&nocache=true",
  },
  {
    key: "pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20neat%20stack%20of%20folded%20light%20blue%20denim%20jeans%20on%20a%20white%20wooden%20bench%2C%20a%20small%20brown%20leather%20belt%20coiled%20beside%20them%2C%20bright%20clean%20studio%20light%2C%20fresh%20minimal%20apparel%20photography%2C%20crisp%20denim%20texture%20and%20calm%20composition&width=600&height=600&seq=cat-pants-01&orientation=squarish&nocache=true",
  },
  {
    key: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20single%20dusty%20rose%20baseball%20cap%20placed%20on%20a%20smooth%20stone%20surface%20beside%20a%20pair%20of%20sunglasses%2C%20soft%20overcast%20daylight%2C%20minimal%20accessories%20flat%20lay%20photography%2C%20muted%20warm%20tones%2C%20clean%20and%20modern%20styling&width=600&height=600&seq=cat-headwear-01&orientation=squarish&nocache=true",
  },
  {
    key: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20coordinated%20cream%20and%20terracotta%20tracksuit%20folded%20in%20a%20tidy%20stack%20on%20a%20rattan%20stool%2C%20warm%20natural%20light%2C%20boutique%20athleisure%20flat%20lay%20photography%2C%20soft%20earthy%20palette%2C%20relaxed%20and%20premium%20styling&width=600&height=600&seq=cat-sets-01&orientation=squarish&nocache=true",
  },
  {
    key: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20cotton%20undergarments%20folded%20neatly%20inside%20a%20light%20wicker%20basket%20lined%20with%20a%20beige%20cloth%2C%20gentle%20morning%20light%2C%20airy%20intimate%20apparel%20photography%2C%20fresh%20neutral%20palette%2C%20tasteful%20and%20minimal%20composition&width=600&height=600&seq=cat-underwear-01&orientation=squarish&nocache=true",
  },
  {
    key: "jerseys",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20vibrant%20sports%20jersey%20displayed%20flat%20on%20a%20charcoal%20grey%20surface%20with%20subtle%20geometric%20shadows%2C%20bold%20clean%20studio%20lighting%2C%20modern%20sportswear%20product%20photography%2C%20crisp%20fabric%20detail%20and%20energetic%20composition&width=600&height=600&seq=cat-jerseys-01&orientation=squarish&nocache=true",
  },
  {
    key: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20minimal%20flat%20lay%20of%20a%20silver%20wristwatch%2C%20sunglasses%20and%20a%20thin%20leather%20bracelet%20arranged%20on%20a%20textured%20cream%20paper%20background%2C%20soft%20studio%20light%2C%20premium%20accessories%20photography%2C%20elegant%20negative%20space%20and%20refined%20styling&width=600&height=600&seq=cat-accessories-01&orientation=squarish&nocache=true",
  },
  {
    key: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20sturdy%20canvas%20and%20leather%20backpack%20leaning%20against%20a%20light%20concrete%20wall%20beside%20a%20green%20leafy%20plant%2C%20warm%20afternoon%20sunlight%2C%20urban%20lifestyle%20product%20photography%2C%20natural%20tones%20and%20relaxed%20composition&width=600&height=600&seq=cat-bags-01&orientation=squarish&nocache=true",
  },
  {
    key: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Several%20rolled%20genuine%20leather%20belts%20in%20tan%20brown%20and%20black%20arranged%20in%20a%20row%20on%20a%20smooth%20walnut%20wooden%20surface%2C%20warm%20directional%20light%2C%20premium%20accessories%20photography%2C%20rich%20leather%20texture%20and%20orderly%20composition&width=600&height=600&seq=cat-belts-01&orientation=squarish&nocache=true",
  },
  {
    key: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=An%20elegant%20glass%20perfume%20bottle%20with%20a%20subtle%20golden%20liquid%20standing%20on%20a%20marble%20tray%20beside%20a%20sprig%20of%20white%20flowers%2C%20soft%20bright%20light%2C%20luxury%20fragrance%20photography%2C%20delicate%20reflections%20and%20refined%20minimalist%20styling&width=600&height=600&seq=cat-perfumes-01&orientation=squarish&nocache=true",
  },
  {
    key: "other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20cheerful%20flat%20lay%20of%20assorted%20everyday%20items%20including%20socks%2C%20a%20cap%2C%20a%20keychain%20and%20a%20small%20notebook%20arranged%20in%20a%20light%20woven%20basket%20on%20a%20cream%20background%2C%20bright%20airy%20light%2C%20playful%20ecommerce%20photography%2C%20fresh%20and%20tidy%20composition&width=600&height=600&seq=cat-other-01&orientation=squarish&nocache=true",
  },
];